import axios from "axios";

const API_URL = `${process.env.REACT_APP_API_URL}`;

const http = axios.create({
  baseURL: API_URL,
  withCredentials: true,
  headers: { "Content-Type": "application/json" },
});

http.interceptors.response.use(
  (res) => res,
  (error) => {
    const { response } = error || {};
    const err = new Error(
      response?.data?.message ||
      response?.statusText ||
      error?.message ||
      "Request failed"
    );
    err.status = response?.status;
    err.data = response?.data;
    throw err;
  }
);

const q = (path, query) => {
  if (!query) return path;
  const usp = new URLSearchParams();
  Object.entries(query).forEach(([k, v]) => {
    if (v === undefined || v === null || v === "") return;
    if (Array.isArray(v)) v.forEach((x) => usp.append(k, x));
    else usp.append(k, v);
  });
  const qs = usp.toString();
  return qs ? `${path}?${qs}` : path;
};

const apiGet    = (path)           => http.get(path).then((r) => r.data);
const apiPost   = (path, data)     => http.post(path, data).then((r) => r.data);
const apiPatch  = (path, data)     => http.patch(path, data).then((r) => r.data);
const apiDelete = (path)           => http.delete(path).then((r) => r.data);


export const getCategories = () => apiGet("/tasks/categories");
export const fetchTasks = (query) => apiGet(q("/tasks", query));
export const createTask = (payload) =>
  apiPost("/tasks", payload);
export const updateTask = (id, payload) =>
  apiPatch(`/tasks/${id}`, payload);
export const toggleTask = (id) => apiPatch(`/tasks/${id}/toggle`);
export const deleteTask = (id) => apiDelete(`/tasks/${id}`);
export const bulkDeleteTasks = (ids) => apiPost("/tasks/bulk-delete", { ids });
